import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { initAnalytics } from "./utils/analytics";

initAnalytics();

const root = ReactDOM.createRoot(
  document.getElementById("root")
);

root.render(
  <HelmetProvider>
    <BrowserRouter basename={process.env.PUBLIC_URL}>
      <App />
    </BrowserRouter>
  </HelmetProvider>
);

reportWebVitals();
